import { Dispatch } from "@reduxjs/toolkit";
import {
    getEmployeeContracts,
    getEmployeeLoans,
    getEmployeePaySlips,
    getEmployeeRecords,
    getEmployeeVacations,
    setCancelApprovedCoupon,
} from "../../../api/signalApi";
import {
    setCancelApprovedCouponData,
    setCoupons,
    setLoadingCancelApprovedCoupon,
    setLoadingContracts,
    setLoadingCoupons,
    setLoadingLoans,
    setLoadingPaymentSlips,
    setLoadingRecords,
    setLoadingVacations
} from "./documentsSlice";
import { getEmployeeCoupons } from "../../../api/s10DocumentsApi";
import { S10EmployeesCouponsRequest } from "../../../interfaces/s10Employees.interface";
import { EmployeCoupons } from "../../../interfaces/employeeDocuments.interface";
import { EMPLOYEE_CONTRACTS_ONE, EMPLOYEE_CONTRACTS_THREE, EMPLOYEE_CONTRACTS_TWO, EMPLOYEE_LOANS_ONE, EMPLOYEE_LOANS_THREE, EMPLOYEE_LOANS_TWO, EMPLOYEE_PAYMENT_SLIPS_ONE, EMPLOYEE_PAYMENT_SLIPS_THREE, EMPLOYEE_PAYMENT_SLIPS_TWO, EMPLOYEE_RECORDS_ONE, EMPLOYEE_RECORDS_THREE, EMPLOYEE_RECORDS_TWO } from "../../../constants/signalRequestConsts";
import { store } from "../../store";


// @FiltroFirmado TINYINT = 0 --0:Todos 1:Firmados 2:Sin Firmar
export const searchEmployeePaySlips = (signedFilter: 0 | 1 | 2, requestId: (typeof EMPLOYEE_PAYMENT_SLIPS_ONE | typeof EMPLOYEE_PAYMENT_SLIPS_TWO |  typeof EMPLOYEE_PAYMENT_SLIPS_THREE)) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoadingPaymentSlips({loading: true, requestId}));
        await getEmployeePaySlips(signedFilter, requestId);
    }
}

export const searchEmployeeVacations = () => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoadingVacations(true));
        await getEmployeeVacations();
    }
}

export const searchEmployeeRecords = (status: 0 | 1 | 2, requestId: typeof EMPLOYEE_RECORDS_ONE | typeof EMPLOYEE_RECORDS_TWO | typeof EMPLOYEE_RECORDS_THREE) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoadingRecords({loading: true, requestId}));
        await getEmployeeRecords(status, requestId);
    }
}

export const searchEmployeeContracts = (signedFilter: 0 | 1 | 2, requestId: (typeof EMPLOYEE_CONTRACTS_ONE | typeof EMPLOYEE_CONTRACTS_TWO |  typeof EMPLOYEE_CONTRACTS_THREE)) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoadingContracts({loading: true, requestId}));
        await getEmployeeContracts(signedFilter, requestId);
    }
}

/*
sp que lista los prestamos por persona:
[dbo].[s10_15_Identificador_ListarPrestamosPorEstado]
@CodIdentificador VARCHAR(8),
@Estado TINYINT --0:Pendientes 1:Historicos
*/
export const searchEmployeeLoans = (state: 0 | 1, requestId: (typeof EMPLOYEE_LOANS_ONE | typeof EMPLOYEE_LOANS_TWO |  typeof EMPLOYEE_LOANS_THREE), pageQuantity: number, pageNumber: number) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoadingLoans({loading: true, requestId}));
        await getEmployeeLoans(state, requestId, pageQuantity, pageNumber);
    }
}

export const searchEmployeeCoupons = (props: S10EmployeesCouponsRequest) => {
	const {couponsLoadingPending, couponsLoading} = store.getState().documents;
    return async (dispatch: Dispatch) => {
        if (props.onlyPendings && couponsLoadingPending) {
            return;
        } else if (couponsLoading) {
            return;
        }
        dispatch(setLoadingCoupons({
            loading: true,
            onlyPending: props.onlyPendings || false,
        }));
        const result = await getEmployeeCoupons(props);
        dispatch(setCoupons({
            Pages: result.data?.Pages,
            Count: result.data?.Count,
            Data: result.data?.Data,
            onlyPending: props.onlyPendings,
        }));
    }
}


export const cancelApprovedCoupon = (couponToCancelData: EmployeCoupons) => {
    return async (dispatch: Dispatch) => {
        dispatch(setLoadingCancelApprovedCoupon(true));
        await setCancelApprovedCoupon(couponToCancelData.ApprovalCode);
        dispatch(setCancelApprovedCouponData(couponToCancelData));
    }
}


